var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppAddUpdateModal',{attrs:{"id":_vm.id,"title":_vm._f("capitalize")(_vm.$t(_vm.$getConst.pages.pageUsers.affect_role_scopes))},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('UserForm',{attrs:{"modal_id":_vm.id,"userToEdit":_vm.userToEdit}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }